import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { comnUtils } from "@/comn/utils";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
    useTab,
} from "@/comn/hooks";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";
import { SF_FEE_RGSR_DTL, SG_BLL_ITM_LIST, URLS, APIS } from "@/tz/go/egaz/osci/lpco/fee/services/OsciLpcoFeeService";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";

export const OSCI0205008S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId, back } = usePage({
        auth: ["auth_osci0006", "auth_osci0008", "auth_osci0009", "auth_osci0021", "auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { uuid, appNo, appDgr } = useParams();
    // Fee id resolved from the route: direct on /:uuid, looked up on the My Task /:appNo/:appDgr path
    // !== 라우트에서 확정한 수수료 ID: /:uuid 는 직접, 나의 할일 경로 /:appNo/:appDgr 는 조회로 얻는다 ==!
    const [feeId, setFeeId] = useState<any>(uuid);

    const location = useLocation();
    let param = { ...location.state };
    const menuTp = param?.menuTp || "APRV";

    let tabSchemaList: any = [];

    const [visible, setVisible] = useState(false);
    const [rcveVisible, setRcveVisible] = useState(false);

    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setpayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);
    const [cfrm, setCfrmVisible] = useState(false);
    const [cmbiBllYn, setCmbiBllYn] = useState(false);
    const [issYn, setIssYn] = useState(false);
    const [tzsYn, setTzsYn] = useState(false);
    const [vsdSaveBtn, setVsdSaveBtn] = useState(false);
    const [vsdEditBtn, setVsdEditBtn] = useState(false);
    const [vsdCfrmBtn, setVsdCfrmBtn] = useState(false);
    const [vsdIssBtn, setVsdIssBtn] = useState(false);
    const [vsdRtrnBtn, setVsdRtrnBtn] = useState(false);

    const [vsdItms, setVsdItms] = useState(false);

    const [comnCdList, setComnCdList] = useState([]);
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    const [exrt, setExrt] = useState();

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0060" }, // Currency Code	!== 통화 코드 ==!
            { area: "comnCd", comnCd: "OSC0123" }, // Fee Impose Type Code	!== 수수료 부과 유형 코드 ==!
        ],
    });

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Application Ddtail Info Form !== 신청서 상세 정보 Form ==!
        newAppDtl: useForm({
            defaultSchema: SF_FEE_RGSR_DTL,
            defaultValues: {
                // ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    const readyFunc = {
        readyBtn: (data: any) => {
            let _manlYn = data.feeImpsCtraCd === "M";
            let _cfrmYn = data.cfrmYn === "Y";
            let _issYn = data.issYn === "Y";
            let _tzsYn = data.currCd === "TZS";
            let _cmbiYn = data.cmbiBllYn === "Y";
            let _vsdSaveBtn = false;
            let _vsdEditBtn = false;
            let _vsdCfrmBtn = false;
            let _vsdIssBtn = false;

            let _intfYn = data.feeImpsCtraCd === "N";

            let _cmbnAlreadyIssYn = data.cmbnBllAlreadyIssYn === "Y";

            let _usdOrgYn = true;
            // data.orgCd === "OGAZ0041" || // DLD
            // data.orgCd === "OGAZ0033" || //POE
            // data.orgCd === "OGAM0001"; //test

            if (_usdOrgYn && _manlYn) form.newAppDtl.setSchema("currCd", { edit: true });

            setTzsYn(_tzsYn);
            setIssYn(_issYn);

            if (_cmbiYn && _manlYn && !_cfrmYn && !_cmbnAlreadyIssYn) {
                _vsdCfrmBtn = true;
            }

            if ((!_cmbiYn || _cmbnAlreadyIssYn) && !_issYn && _manlYn && !_cfrmYn) {
                _vsdIssBtn = true;
            }

            if (!_cfrmYn && !_issYn && !_intfYn) _vsdSaveBtn = true;
            if (_cfrmYn && !_issYn && !_intfYn && !data.bllMgmtId) _vsdEditBtn = true;

            console.log("asign:" + data.asinOfcrId + "(login user:" + auth.get("usrId") + ")");
            // Only the officer currently assigned to this fee (FP stage) may save/edit/confirm/issue
            let _assignedUsrYn = !!data.asinOfcrId && auth.get("usrId") === data.asinOfcrId;

            _vsdSaveBtn = _vsdSaveBtn && _assignedUsrYn;
            _vsdEditBtn = _vsdEditBtn && _assignedUsrYn;
            _vsdCfrmBtn = _vsdCfrmBtn && _assignedUsrYn;
            _vsdIssBtn = _vsdIssBtn && _assignedUsrYn;

            // Return is shown while Issue Bill, Confirm or Edit is shown, or for a fee waiting for input after a calculation error;
            // the application fee is excluded. Edit means a confirmed fee whose bill has not been created yet.
            // !== 반려는 Issue Bill·Confirm·Edit 버튼이 보이는 동안 또는 계산오류로 입력 대기(WI)인 건만 가능, 신청수수료(03)는 제외.
            //     Edit 은 확정했지만 아직 고지서가 생성되지 않은 수수료다 ==!
            setVsdRtrnBtn(
                (_vsdIssBtn ||
                    _vsdCfrmBtn ||
                    _vsdEditBtn ||
                    (_assignedUsrYn && data.bllSttsCd === "WI" && !_cfrmYn && !_issYn)) &&
                    data.feeImpsTpCd !== "03",
            );

            // Officer comment can be entered until the fee is confirmed or issued, and while Edit is shown (needed for a return)
            // !== 담당자 코멘트는 Confirm·발행 전까지, 그리고 Edit 이 보이는 동안 입력 (반려 사유 입력용) ==!
            form.newAppDtl.setSchema("prcssRsnCn", { edit: (_assignedUsrYn && !_cfrmYn && !_issYn) || _vsdEditBtn });

            setVsdCfrmBtn(_vsdCfrmBtn);
            setVsdIssBtn(_vsdIssBtn);
            setVsdSaveBtn(_vsdSaveBtn);
            setVsdEditBtn(_vsdEditBtn);

            if (data.gfsItmList && data.gfsItmList.length > 0) {
                setVsdItms(true);
                if (_vsdSaveBtn || _vsdCfrmBtn) {
                    setBllItmList(comnUtils.getGridData(data.gfsItmList));
                } else {
                    const filteredList = data.gfsItmList.filter((item: any) => Number(item.bllItmTzsAmt) !== 0);
                    setBllItmList(comnUtils.getGridData(filteredList));
                }
            }

            setExrt(exrt);
            form.newAppDtl.setValue("exrt", exrt);

            if (_vsdSaveBtn || _vsdCfrmBtn) {
                readyFunc.readyCurr(_tzsYn);
            } else {
                form.newAppDtl.setSchema("currCd", { edit: false });
            }
        },
        readyCurr: (_tzsYn: any) => {
            // Fee amount is the GFS item total, so it is not entered directly !== 수수료 금액은 GFS 항목 합계라 직접 입력하지 않는다 ==!
            form.newAppDtl.setSchema("bllAmt", { edit: false });
            form.newAppDtl.setSchema("bllTzsAmt", { edit: false });

            if (_tzsYn) {
                grid.bllItmList.setEdit("cell", "bllItmAmt", false);
                grid.bllItmList.setEdit("cell", "bllItmTzsAmt", true);
            } else {
                grid.bllItmList.setEdit("cell", "bllItmAmt", true);
                grid.bllItmList.setEdit("cell", "bllItmTzsAmt", false);
            }
        },
    };
    const usdToTzs = (usd: any) => {
        if (!usd || !exrt) return 0;
        return Number((usd * exrt).toFixed(2));
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getExchageRate: useFetch({
            api: (data) => {
                return APIS.getExchageRate(data);
            },
            enabled: true,
            onSuccess: (data) => {
                if ((!data.exrt.content || data.exrt.content === 0) && !tzsYn) {
                    modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
                } else {
                    setExrt(data.exrt.content);
                    form.newAppDtl.setValue("exrt", data.exrt.content);
                }
            },
            onError: (error) => {
                modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
            },
        }),
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppInfo: useFetch({
            api: (uuid) => APIS.getAppInfo({ feeId: uuid, orgCd: auth.get("orgCd") }),
            onSuccess: (data) => {
                form.newAppDtl.setValues({
                    ...data.appInfo.content,
                });
                location.state = data.appInfo.content;
                handler.getTabSchemaList(data.appInfo.content);

                if (data.appInfo.content) {
                    const asnmtCfrmDtm = data.appInfo.content.asnmtCfrmDtm;
                    const ofcrPrcssDtm = data.appInfo.content.ofcrPrcssDtm;
                    if (!asnmtCfrmDtm) {
                        setRcveVisible(true);
                    } else {
                        setRcveVisible(false);
                    }

                    if (asnmtCfrmDtm && !ofcrPrcssDtm) {
                        setVisible(true);
                    }
                }
            },
            onError: (error) => {},
        }),
        // Get fee id by application no !== 신청번호로 수수료 ID 조회 ==!
        getFeeIdToAppNo: useFetch({
            api: (appNo, appDgr) => APIS.getFeeIdToAppNo(appNo, appDgr),
            onSuccess: (data) => {
                const rsltFeeId = data.feeId.content;
                if (!rsltFeeId) {
                    modal.openModal({ content: "msg.osc.00147" }); // Missing feeId !== feeId 누락 ==!
                    return;
                }
                setFeeId(rsltFeeId);
                handler.getAppInfo(rsltFeeId);
            },
            onError: (error) => {},
        }),
        // View notification details in detail !== 고지 내역 상세 조회 ==!
        getFeeBllDtl: useFetch({
            api: (feeId) => APIS.getLpcoFeeDtl(feeId),
            onSuccess: (data) => {
                form.newAppDtl.setValues({
                    ...data.lpcoFeeInfo.content,
                });

                readyFunc.readyBtn(data.lpcoFeeInfo.content);
            },
            onError: (error) => {},
            showToast: true,
        }),
        getRprt: useFetch({
            api: () => {
                return lpcoUtils.getRprtLpco(
                    param.appId,
                    ["AP", "CL"].indexOf(form.newAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                );
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        saveFee: useFetch({
            api: (data) => APIS.saveFee({ ...data, bllNo: data.bllNo ? data.bllNo : auth.get("tin"), auth }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                });

                fetch.getFeeBllDtl.fetch(feeId);
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.newAppDtl.setErrors(error.response.data.errors);
                }

                // Business errors (e.g. the fee was already processed in another tab) carry their own message; reload to show the current status
                // !== 업무 오류(다른 탭에서 이미 처리된 수수료 등)는 서버 메시지를 보여 주고, 닫으면 현재 상태로 다시 조회한다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", //An error occurred during processing.
                    onClose: () => {
                        if (serverMsg) fetch.getFeeBllDtl.fetch(feeId);
                    },
                });
            },
        }),
        confirmFee: useFetch({
            api: (data) => APIS.confirmFee({ ...data, bllNo: data.bllNo ? data.bllNo : auth.get("tin"), auth }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                });
                fetch.getFeeBllDtl.fetch(feeId);
                setVsdCfrmBtn(false);
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.newAppDtl.setErrors(error.response.data.errors);
                }

                // Business errors (e.g. the fee was already processed in another tab) carry their own message; reload to show the current status
                // !== 업무 오류(다른 탭에서 이미 처리된 수수료 등)는 서버 메시지를 보여 주고, 닫으면 현재 상태로 다시 조회한다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", //An error occurred during processing.
                    onClose: () => {
                        if (serverMsg) fetch.getFeeBllDtl.fetch(feeId);
                    },
                });
            },
        }),
        issBll: useFetch({
            api: (data) => APIS.issBll({ ...data, bllNo: data.bllNo ? data.bllNo : auth.get("tin"), auth }),
            onSuccess: (data) => {
                // Return to My task when entered from there, mirroring the verification/inspection screens
                // !== 나의 할일에서 진입했으면 그쪽으로 복귀 — 심사·검사 화면과 동일 ==!
                const done = () => {
                    if (menuId === "mytodo") {
                        back();
                    } else {
                        navigate(URLS.osci0205007q);
                    }
                };
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: done,
                    onCancel: done,
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.newAppDtl.setErrors(error.response.data.errors);
                }

                // Business errors (e.g. the fee was already processed in another tab) carry their own message; reload to show the current status
                // !== 업무 오류(다른 탭에서 이미 처리된 수수료 등)는 서버 메시지를 보여 주고, 닫으면 현재 상태로 다시 조회한다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", //An error occurred during processing.
                    onClose: () => {
                        if (serverMsg) fetch.getFeeBllDtl.fetch(feeId);
                    },
                });
            },
        }),
        returnFee: useFetch({
            api: (data) => APIS.returnFee(data),
            onSuccess: (data) => {
                // Return to My task when entered from there !== 나의 할일에서 진입했으면 그쪽으로 복귀 ==!
                const done = () => {
                    if (menuId === "mytodo") {
                        back();
                    } else {
                        navigate(URLS.osci0205007q);
                    }
                };
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: done,
                    onCancel: done,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response?.data?.errorMessage || "msg.osc.00015",
                });
            },
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            if (uuid) {
                await handler.getAppInfo(uuid);
            } else if (appNo) {
                // The My Task path carries appNo/appDgr, so the fee id has to be resolved first
                // !== 나의 할일 경로는 appNo/appDgr 만 실어와 수수료 ID를 먼저 조회해야 한다 ==!
                await fetch.getFeeIdToAppNo.fetch(appNo, appDgr);
            }
            await render.tabView();
        },
        usdToTzs: () => {
            if (!exrt) {
                form.newAppDtl.setValue("bllTzsAmt", "");
            } else {
                const usd = form.newAppDtl.getValue("bllAmt");
                form.newAppDtl.setValue("bllTzsAmt", usdToTzs(usd));
            }
        },
        // Set the fee amount to the GFS item total !== GFS 항목 금액 합계를 수수료 금액에 반영 ==!
        sumGfsAmt: (row: any) => {
            const rows = grid.bllItmList.getData().map((r: any) => (r.__key === row.__key ? row : r));
            const sumAmt = rows.reduce((sum: number, r: any) => sum + Number(r.bllItmAmt || 0), 0);
            form.newAppDtl.setValue("bllAmt", sumAmt);
            form.newAppDtl.setValue("bllTzsAmt", tzsYn ? sumAmt : usdToTzs(sumAmt));
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfo: async (feeId: any) => {
            fetch.getAppInfo.fetch(feeId);
            fetch.getFeeBllDtl.fetch(feeId);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const comnCdList = await lpcoUtils.getCpntList(reqParam);
            comnCdList.map((item: any) => {
                if ("CON" != item.value) {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(comnCdList);

            handler.changeTab(0);
        },
        // Hide existing tab contents when changing tab !== Tab변경 시 기존 탭 내용 숨김처리  ==!
        chanageTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
            setCfrmVisible(false);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        changeTab: async (index: any) => {
            handler.chanageTabVisible();
            let tabList = comnCdList;
            if (tabList && tabList.length > 0) {
                const tabInfo: any = tabList[index];
                switch (tabInfo.value) {
                    case "GEN":
                        setGnrlVisible(true);
                        break;
                    case "TRN":
                        setTrptVisible(true);
                        break;
                    case "INV":
                        setInvcVisible(true);
                        break;
                    case "ITM":
                        setItmVisible(true);
                        break;
                    case "ATC":
                        setAtcmVisible(true);
                        break;
                    case "PAY":
                        setpayInfoVisible(true);
                        break;
                    case "MSG":
                        setMsgVisible(true);
                        break;
                    case "DCL":
                        setDclrVisible(true);
                        break;
                    // case "CON":
                    //     setCfrmVisible(true);
                    //     break;
                }
            }
            tab.tabSchema.setActive(index);
        },
        // Common Bill Amount Validation !== 고지 금액 공통 체크 (GFS 항목 존재/총액 음수/항목 음수/총액-항목합계 일치) ==!
        checkBll: (dtlData: any, itmGridData: any[]) => {
            const totAmt = Number(tzsYn ? dtlData.bllTzsAmt || 0 : dtlData.bllAmt || 0);
            let valid = true;

            if (!tzsYn && !exrt) {
                modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator
                valid = false;
                return { valid, totAmt };
            }

            // GFS 항목 존재 체크
            if (totAmt != 0 && itmGridData.length == 0) {
                const msg = t("msg.osc.00215", { 0: `The GFS code configuration` }); //{0} is missing. Please contact the administrator.
                modal.openModal({ content: msg });
                valid = false;
            }

            const totalFeeAmt = itmGridData.reduce(
                (sum: number, dtl: any) => sum + Number(tzsYn ? dtl.bllItmTzsAmt || 0 : dtl.bllItmAmt || 0),
                0,
            );

            // 총 금액 음수 체크
            if (totAmt < 0) {
                modal.openModal({
                    content: "msg.osc.00286", //The amount must be greater than or equal to 0.
                });
                valid = false;
            }

            // 항목 금액 음수 체크
            if (
                valid &&
                itmGridData.some((dtl: any) => Number(dtl.bllItmAmt || 0) < 0 || Number(dtl.bllItmTzsAmt || 0) < 0)
            ) {
                modal.openModal({
                    content: "msg.osc.00286", //The amount must be greater than or equal to 0.
                });
                valid = false;
            }

            // 총 금액 - 항목 합계 일치 체크
            if (valid && Number(totAmt || 0) !== totalFeeAmt) {
                const msg = t("msg.osc.00054", { 0: `the item amounts.` });
                modal.openModal({ content: msg });
                valid = false;
            }

            return { valid, totAmt };
        },
        saveFee: form.newAppDtl.handleSubmit(
            () => {
                const dtlData = { ...form.newAppDtl.getValues() };
                const itmGridData = grid.bllItmList.getData();

                const { valid } = handler.checkBll(dtlData, itmGridData);

                if (valid) {
                    const data = { ...dtlData, exrt: exrt, gfsItmList: itmGridData };
                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            fetch.saveFee.fetch(data);
                        },
                    });
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        editFee: form.newAppDtl.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.osc.00326", //It has already been confirmed. Would you like to change the fee amount?
                    onConfirm: () => {
                        setVsdCfrmBtn(true);
                        setVsdEditBtn(false);
                        readyFunc.readyCurr(tzsYn);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        confirmFee: form.newAppDtl.handleSubmit(
            () => {
                const dtlData = { ...form.newAppDtl.getValues() };
                const itmGridData = grid.bllItmList.getData();

                const { valid, totAmt } = handler.checkBll(dtlData, itmGridData);

                if (valid) {
                    const data = { ...dtlData, exrt: exrt, gfsItmList: itmGridData };
                    if (totAmt == 0) {
                        modal.openModal({
                            content: "msg.osc.00287",
                            onConfirm: () => {
                                fetch.confirmFee.fetch(data);
                            },
                        });
                    } else {
                        modal.openModal({
                            content: "msg.osc.00280",
                            onConfirm: () => {
                                fetch.confirmFee.fetch(data);
                            },
                        });
                    }
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        issueBill: form.newAppDtl.handleSubmit(
            () => {
                const dtlData = { ...form.newAppDtl.getValues() };
                const itmGridData = grid.bllItmList.getData();

                const { valid, totAmt } = handler.checkBll(dtlData, itmGridData);

                if (valid) {
                    const data = { ...dtlData, exrt: exrt, gfsItmList: itmGridData };
                    if (totAmt == 0) {
                        modal.openModal({
                            content: "msg.osc.00287",
                            onConfirm: () => {
                                fetch.issBll.fetch(data);
                            },
                        });
                    } else {
                        modal.openModal({
                            content: "msg.osc.00090",
                            onConfirm: () => {
                                fetch.issBll.fetch(data);
                            },
                        });
                    }
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        returnFee: () => {
            const prcssRsnCn = form.newAppDtl.getValue("prcssRsnCn");
            // Comment is required for a return !== 반려 시 코멘트 필수 ==!
            if (!prcssRsnCn || !String(prcssRsnCn).trim()) {
                modal.openModal({ content: t("msg.osc.00051", { 0: t("L_FEE_RMRK") }) }); // Please enter Fee Payment Remarks.
                return;
            }
            modal.openModal({
                content: "msg.osc.00092",
                onConfirm: () => {
                    fetch.returnFee.fetch({ feeId: feeId, prcssRsnCn: prcssRsnCn });
                },
            });
        },
    };

    const render = {
        tabView: () => {
            const tabPanelList: any = [];
            const tabList = comnCdList;
            if (tabList != undefined) {
                tabList.map((item: any) => {
                    if ("GEN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{gnrl && <APP_DTL_GEN state={param} />}</Tab.Panel>,
                        );
                    } else if ("TRN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{trpt && <APP_DTL_TRPT state={param} />}</Tab.Panel>,
                        );
                    } else if ("INV" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{invc && <APP_DTL_INVC state={param} />}</Tab.Panel>,
                        );
                    } else if ("ITM" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{itm && <APP_DTL_ITM state={param} />}</Tab.Panel>,
                        );
                    } else if ("ATC" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{atcm && <APP_DTL_ATCM state={param} />}</Tab.Panel>,
                        );
                    } else if ("PAY" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{payInfo && <APP_DTL_PAY_INFO state={param} />}</Tab.Panel>,
                        );
                    } else if ("MSG" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{msg && <APP_DTL_MSG state={param} />}</Tab.Panel>,
                        );
                    } else if ("DCL" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{dclr && <APP_DTL_DCLR state={param} />}</Tab.Panel>,
                        );
                    }
                });
            }
            return tabPanelList;
        },
        grid_bllItmList: {
            head: {},
            cell: {},
            edit: {
                bllItmAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmAmt}
                                onChange={(v) => {
                                    if (!tzsYn) {
                                        const row = { ...rowValues, bllItmAmt: v, bllItmTzsAmt: usdToTzs(v) };
                                        grid.bllItmList.updateRow(row);
                                        handler.sumGfsAmt(row);
                                    }
                                }}
                                edit={true}
                                required={true}
                            />
                        </>
                    );
                },
                bllItmTzsAmt: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <>
                            <FormControl
                                type="number"
                                value={rowValues.bllItmAmt}
                                onChange={(v) => {
                                    if (tzsYn) {
                                        const row = { ...rowValues, bllItmAmt: v, bllItmTzsAmt: v };
                                        grid.bllItmList.updateRow(row);
                                        handler.sumGfsAmt(row);
                                    }
                                }}
                                edit={true}
                                required={true}
                            />
                        </>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (vsdSaveBtn) {
            readyFunc.readyCurr(tzsYn);

            if (tzsYn) {
                const bllAmt = form.newAppDtl.getValue("bllAmt");
                form.newAppDtl.setValue("bllTzsAmt", bllAmt);

                // grid
                const rows = grid.bllItmList.getData();
                rows.forEach((row: any) => {
                    grid.bllItmList.updateRow({
                        ...row,
                        bllItmTzsAmt: row.bllItmAmt,
                    });
                });
            } else {
                const bllAmt = form.newAppDtl.getValue("bllAmt");
                form.newAppDtl.setValue("bllTzsAmt", usdToTzs(bllAmt));

                // grid
                const rows = grid.bllItmList.getData();
                rows.forEach((row: any) => {
                    grid.bllItmList.updateRow({
                        ...row,
                        bllItmTzsAmt: usdToTzs(row.bllItmAmt),
                    });
                });
            }
        }
    }, [tzsYn, exrt]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNo} />
                            <Group.Control {...form.newAppDtl.schema.ucrNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNm} />
                            <Group.Control {...form.newAppDtl.schema.appTpNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.newAppDtl.schema.appStatNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.bllSttsCd} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.feeImpsTpCd} />
                            <Group.Control {...form.newAppDtl.schema.exrt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.newAppDtl.schema.currCd}
                                onChange={(v) => {
                                    setTzsYn(v === "TZS");
                                    if (!!!exrt && v !== "TZS") {
                                        modal.openModal({ content: "msg.osc.00291" }); //There is no exchange rate information. Please contact the administrator

                                        setVsdCfrmBtn(false);
                                        setVsdIssBtn(false);
                                        setVsdSaveBtn(false);
                                    }
                                }}
                            />
                            <Group.Control {...form.newAppDtl.schema.calcBllAmt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.newAppDtl.schema.bllAmt}
                                onChange={(v) => {
                                    if (!tzsYn) {
                                        handler.usdToTzs();
                                    }
                                }}
                            />
                            <Group.Control
                                {...form.newAppDtl.schema.bllTzsAmt}
                                onChange={(v) => {
                                    if (tzsYn) {
                                        form.newAppDtl.setValue("bllAmt", v);
                                    }
                                }}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.rmrk} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.prcssRsnCn} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                    {vsdItms && (
                        <>
                            {" "}
                            <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                        </>
                    )}

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    if (menuId === "mytodo") {
                                        back();
                                    } else {
                                        navigate(URLS.osci0205007q);
                                    }
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {/* <Button
                                variant="secondary"
                                onClick={() => {
                                    fetch.getRprt.fetch();
                                }}
                            >
                                {t("B_PRNT")}
                            </Button> */}
                            {vsdRtrnBtn && (
                                <Button variant="secondary" onClick={handler.returnFee}>
                                    {t("B_RTRN")}
                                </Button>
                            )}
                            {vsdSaveBtn && <Button role="save" onClick={handler.saveFee}></Button>}
                            {vsdEditBtn && <Button role="edit" onClick={handler.editFee}></Button>}
                            {vsdCfrmBtn && <Button role="confirm" onClick={handler.confirmFee}></Button>}
                            {vsdIssBtn && (
                                <Button variant="warning" onClick={handler.issueBill}>
                                    Issue Bill
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            // 탭이 변경되었을때 index 번호와 onChange 이벤트를 호출
                            handler.changeTab(index);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
